import {useEffect, useState} from 'react';
import {Link, useHistory, useLocation, useParams} from 'react-router-dom';
import Api from '../api/api';
import stringHelpers from '../../utilities/stringHelpers';
import roleUtilities from '../../utilities/roleUtilities';
import {isDateTimeElapsed, isToDateAfterFromDate, toInputFieldDateTimeString} from '../../utilities/dateUtilities';
import Loader from '../shared/loader';
import arrayUtilities from '../../utilities/arrayUtilities';
import {TimeRangeSlider} from '../shared/timeRangeSlider';
import {ErrorModal} from '../../utilities/errorModal';
import {Modal} from 'react-bootstrap';
import formUtilities from '../../utilities/formUtilities';
import {MinutesInputWithUnit} from '../shared/minutesInputWithUnit';
import Enums from '../../utilities/enum';
import {AnprSettingDisplay} from "./anprSettingDisplay";
import {MultiValueRangeSlider} from "../shared/multiValueRangeSlider";

export const AnprSettingAddEdit = ({user, organisationId, token}) => {
    const {clientId, siteId, rangeId} = useParams()
    const history = useHistory()
    const location = useLocation()
    const returnUrl = `/organisation/${organisationId}/client/${clientId}/site/${siteId}`
    const isStandardAnpr = rangeId === 'standard-anpr'
    const isNew = stringHelpers.isNullOrEmpty(rangeId)
    const [canSubmit, setCanSubmit] = useState(false);
    const [isInEdit, setIsInEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false)
    const [anprSetting, setAnprSetting] = useState({})
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const [name, setName] = useState(null);
    const [maxAllowedParkingDurationMinutes, setMaxAllowedParkingDurationMinutes] = useState(0);
    const [considerationPeriodMinutes, setConsiderationPeriodMinutes] = useState(0);
    const [allowListEntryGraceMinutes, setAllowListEntryGraceMinutes] = useState(0);
    const [allowListExitGraceMinutes, setAllowListExitGraceMinutes] = useState(0);
    const [allowListDurationGraceMinutes, setAllowListDurationGraceMinutes] = useState(0);
    const [overstayContraventionId, setOverstayContraventionId] = useState(null);
    const [contraventionForOverStayEnabled, setContraventionForOverStayEnabled] = useState(false);
    const [contraventionsForNotOnAllowListEnabled, setContraventionsForNotOnAllowListEnabled] = useState(false);
    const [contraventionsForNotOnAllowList, setContraventionsForNotOnAllowList] = useState(null);
    const [contraventionForShortReturnEnabled, setContraventionForShortReturnEnabled] = useState(false);
    const [shortReturnContraventionId, setShortReturnContraventionId] = useState(null);
    const [enforceShortReturnForAllowListEntries, setEnforceShortReturnForAllowListEntries] = useState(false);
    const [enforcementLimitMinutes, setEnforcementLimitMinutes] = useState(0);
    const [noReturnWithinMinutes, setNoReturnWithinMinutes] = useState(0);
    const [isPayAndDisplayEnabled, setIsPayAndDisplayEnabled] = useState(false);
    const [isNonEnforcement, setIsNonEnforcement] = useState(false);
    const [failedToMakePaymentContraventionId, setFailedToMakePaymentContraventionId] = useState(null);
    const [overstayedPaymentPeriodContraventionId, setOverstayedPaymentPeriodContraventionId] = useState(null);
    const [freeParkingMinutes, setFreeParkingMinutes] = useState(0);
    const [siteContraventions, setSiteContraventions] = useState(null);
    const [allContraventions, setAllContraventions] = useState(null);
    const [site, setSite] = useState(null);
    const [isEnabled, setIsEnabled] = useState(false)
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [validOnlyOnSpecificDays, setValidOnlyOnSpecificDays] = useState(false)
    const [validityDays, setValidityDays] = useState([{
        label: "Monday", isEnabled: false,
    }, {
        label: "Tuesday", isEnabled: false,
    }, {
        label: "Wednesday", isEnabled: false,
    }, {
        label: "Thursday", isEnabled: false,
    }, {
        label: "Friday", isEnabled: false,
    }, {
        label: "Saturday", isEnabled: false,
    }, {
        label: "Sunday", isEnabled: false,
    }])

    const [validOnlyAtSpecificTimes, setValidOnlyAtSpecificTimes] = useState(false)
    const [enabledTimes, setEnabledTimes] = useState({
        from: "00:00:00", to: "23:59:00"
    })

    const [overnightStaySettingsEnabled, setOvernightStaySettingsEnabled] = useState(false);
    const [overnightStayContraventionId, setOvernightStayContraventionId] = useState(null);
    const [overnightStayGraceMinutes, setOvernightStayGraceMinutes] = useState(0);
    const [overnightStayStartTime, setOvernightStayStartTime] = useState(60);
    const [overnightStayStartTimeFormattedString, setOvernightStayStartTimeFormattedString] = useState(stringHelpers.formatMinutesToTwentyFourHourClock(overnightStayStartTime));
    const [overnightStayEndTime, setOvernightStayEndTime] = useState(300);
    const [overnightStayEndTimeFormattedString, setOvernightStayEndTimeFormattedString] = useState(stringHelpers.formatMinutesToTwentyFourHourClock(overnightStayEndTime));

    const [errorMessage, setErrorMessage] = useState(null)

    const getRange = () => {
        Api.getSiteVariableAnprRange(data => {
            setAnprSetting(data)
            setInitialValues(data)
        }, error => console.log(error), siteId, rangeId, organisationId, token)

    }

    const getSite = () => {
        Api.getSite((data) => {
            setSite(data)
            const standardAnprDataObject = {
                ...data, id: "standard-anpr", name: "Standard ANPR", siteId: data.id, isEnabled: data.isAnprEnabled,
            }
            setAnprSetting(standardAnprDataObject);
            setInitialValues(standardAnprDataObject);
        }, (error) => console.log(error), siteId, organisationId, token,)
    };

    const setInitialValues = (settingObject) => {
        setName(settingObject.name)
        setIsEnabled(settingObject.isEnabled);
        if (!isStandardAnpr) {
            setStartDate(!stringHelpers.isNullOrEmpty(settingObject.startDate) ? settingObject.startDate : null);
            setEndDate(!stringHelpers.isNullOrEmpty(settingObject.endDate) ? settingObject.endDate : null);
            const daysValid = validityDays.map(item => ({
                ...item, isEnabled: settingObject[item.label.toLowerCase()],
            }))
            setValidityDays(daysValid)
            setValidOnlyOnSpecificDays(daysValid.some(item => item.isEnabled))

            setValidOnlyAtSpecificTimes(!stringHelpers.isNullOrEmpty(settingObject.enabledFromTime) && !stringHelpers.isNullOrEmpty(settingObject.enabledToTime))
            setEnabledTimes({
                from: !stringHelpers.isNullOrEmpty(settingObject.enabledFromTime) ? settingObject.enabledFromTime : "00:00:00",
                to: !stringHelpers.isNullOrEmpty(settingObject.enabledToTime) ? settingObject.enabledToTime : "23:59:59"
            })

            setIsNonEnforcement(settingObject.isNonEnforcement)
            setContraventionsForNotOnAllowListEnabled(false)
        } else {
            setIsNonEnforcement(false)
        }
        setContraventionsForNotOnAllowListEnabled(!stringHelpers.isNullOrEmpty(settingObject.notOnAllowListContraventionId));
        setContraventionsForNotOnAllowList(settingObject.notOnAllowListContraventionId)
        setOvernightStaySettingsEnabled(!stringHelpers.isNullOrEmpty(settingObject.overnightStayContraventionId))
        setOvernightStayContraventionId(settingObject.overnightStayContraventionId)
        setOvernightStayGraceMinutes(settingObject.overnightStayGraceMinutes ?? 0)
        setOvernightStayStartTime(!stringHelpers.isNullOrEmpty(settingObject.overnightStayStartTime)
            ? stringHelpers.timeStringToMidnightOffset(settingObject.overnightStayStartTime)
            : 60)
        setOvernightStayEndTime(!stringHelpers.isNullOrEmpty(settingObject.overnightStayEndTime)
            ? stringHelpers.timeStringToMidnightOffset(settingObject.overnightStayEndTime)
            : 300)
        setContraventionForOverStayEnabled(!stringHelpers.isNullOrEmpty(settingObject.overstayContraventionId))
        setMaxAllowedParkingDurationMinutes(settingObject.maxAllowedParkingDurationMinutes);
        setConsiderationPeriodMinutes(settingObject.considerationPeriodMinutes);
        setAllowListEntryGraceMinutes(settingObject.allowListEntryGraceMinutes);
        setAllowListExitGraceMinutes(settingObject.allowListExitGraceMinutes);
        setAllowListDurationGraceMinutes(settingObject.allowListDurationGraceMinutes)
        setEnforcementLimitMinutes(settingObject.enforcementLimitMinutes);
        setNoReturnWithinMinutes(settingObject.noReturnWithinMinutes);
        setFailedToMakePaymentContraventionId(settingObject.failedToMakePaymentContraventionId)
        setOverstayedPaymentPeriodContraventionId(settingObject.overstayedPaymentPeriodContraventionId)
        setIsPayAndDisplayEnabled(settingObject.isPayAndDisplayEnabled);
        setOverstayContraventionId(settingObject.overstayContraventionId)
        setContraventionForOverStayEnabled(!stringHelpers.isNullOrEmpty(settingObject.overstayContraventionId))
        setContraventionForShortReturnEnabled(!stringHelpers.isNullOrEmpty(settingObject.shortReturnContraventionId))
        setShortReturnContraventionId(settingObject.shortReturnContraventionId)
        setEnforceShortReturnForAllowListEntries(!!settingObject.enforceShortReturnForAllowListEntries)
        setFreeParkingMinutes(settingObject.freeParkingMinutes)
    }
    const showContraventionSettings = isStandardAnpr || !isNonEnforcement
    const submit = () => {
        setIsLoading(true)
        if (isStandardAnpr && site) {
            Api.editSite((data) => {
                setIsLoading(false)
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                }
                else {
                    setIsInEdit(false)
                    getSite()
                    setErrorMessage("");
                }
            }, (error) => setErrorMessage(error.errorMessage),
                site.name, site.siteCode, site.iasCode, site.isActive, site.jurisdiction, site.addressLine1, site.addressLine2, site.addressLine3, site.postCode, site.townOrCity,
                site.iasEnabled, site.bpaEnabled, site.bpaCode, site.pofaEnabled, isEnabled,
                maxAllowedParkingDurationMinutes, considerationPeriodMinutes, allowListEntryGraceMinutes, allowListExitGraceMinutes, allowListDurationGraceMinutes,
                !stringHelpers.isNullOrEmpty(overstayContraventionId) ? overstayContraventionId : null,
                !stringHelpers.isNullOrEmpty(contraventionsForNotOnAllowList) ? contraventionsForNotOnAllowList : null,
                !stringHelpers.isNullOrEmpty(shortReturnContraventionId) ? shortReturnContraventionId : null,
                enforcementLimitMinutes, noReturnWithinMinutes, site.contractExpiry,
                site.payAndDisplaySpaces, site.preAllocatedSpaces, site.disabledSpaces, site.permitSpaces, site.otherSpaces,
                site.permitPrefix, site.parkonomySiteCode, site.ringGoZone, site.payByPhoneLocationId, site.justParkLocationId, site.tap2ParkLocationId, site.parkBunnyLocationId, site.ipsLocationId, site.conviousLocationId,
                !stringHelpers.isNullOrEmpty(overstayedPaymentPeriodContraventionId) ? overstayedPaymentPeriodContraventionId : null,
                !stringHelpers.isNullOrEmpty(failedToMakePaymentContraventionId) ? failedToMakePaymentContraventionId : null,
                isPayAndDisplayEnabled,
                overnightStaySettingsEnabled ? overnightStayContraventionId : null,
                stringHelpers.midnightOffsetToTimeString(overnightStayStartTime), stringHelpers.midnightOffsetToTimeString(overnightStayEndTime), Number(overnightStayGraceMinutes),
                site.maximumCancellationsPerMonth,
                site.autoAssignUserId, site.vehicleAnalyticsEnabled, site.regionId,
                site.lookingForCarParkLocationId,
                site.newParkLocationId,
                site.parksoLocationId,
                freeParkingMinutes,
                site.myCarPassLocationId,
                site.preventDuplicateBreaches,
                enforceShortReturnForAllowListEntries,
                site.debtCollectionProviderId,
                organisationId, site.id, clientId, token);
        } else if (!isNew) {
            Api.editSiteVariableAnprRange(data => {
                setIsLoading(false)
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                }
                else {
                    setIsInEdit(false)
                    getRange()
                    setErrorMessage("");
                }
            }, err => {
                console.log(err)
                setErrorMessage(err.errorMessage)
                setIsLoading(false)
            }, name, !stringHelpers.isNullOrEmpty(startDate) ? startDate : null, !stringHelpers.isNullOrEmpty(endDate) ? endDate : null, validOnlyAtSpecificTimes ? enabledTimes.from : null, validOnlyAtSpecificTimes ? enabledTimes.to : null, ...validityDays.map(day => day.isEnabled), isNonEnforcement, isPayAndDisplayEnabled, maxAllowedParkingDurationMinutes, considerationPeriodMinutes, enforcementLimitMinutes, !stringHelpers.isNullOrEmpty(overstayContraventionId) ? overstayContraventionId : null, !stringHelpers.isNullOrEmpty(shortReturnContraventionId) ? shortReturnContraventionId : null, failedToMakePaymentContraventionId, allowListEntryGraceMinutes, allowListExitGraceMinutes, allowListDurationGraceMinutes, noReturnWithinMinutes, overstayedPaymentPeriodContraventionId, isEnabled, freeParkingMinutes, rangeId, siteId, organisationId, token,)
        } else {
            Api.addSiteVariableAnprRange(data => {
                setIsLoading(false)
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                }
                else {
                    history.push(`/organisation/${organisationId}/client/${clientId}/site/${siteId}/anpr-settings/${data.id}`)
                }
            }, error => {
                console.log(error)
                setErrorMessage(error.errorMessage)
                setIsLoading(false)
            }, name, !stringHelpers.isNullOrEmpty(startDate) ? startDate : null, !stringHelpers.isNullOrEmpty(endDate) ? endDate : null, validOnlyAtSpecificTimes ? enabledTimes.from : null, validOnlyAtSpecificTimes ? enabledTimes.to : null, ...validityDays.map(day => day.isEnabled), isNonEnforcement, isPayAndDisplayEnabled, maxAllowedParkingDurationMinutes, considerationPeriodMinutes, enforcementLimitMinutes, overstayContraventionId, shortReturnContraventionId, failedToMakePaymentContraventionId, allowListEntryGraceMinutes, allowListExitGraceMinutes, allowListDurationGraceMinutes, noReturnWithinMinutes, overstayedPaymentPeriodContraventionId, isEnabled, freeParkingMinutes, siteId, organisationId, token,)
        }
    }

    const getSiteContraventions = function () {
        Api.getSiteContraventions(
            (data) => setSiteContraventions(data),
            (error) => console.log(error),
            organisationId, siteId, token)
    };

    useEffect(() => {
        if (isNew) {
            setIsInEdit(true)
        } else {
            setIsInEdit(false)
            if (isStandardAnpr) {
                getSite()
            } else {
                getRange()
            }
        }
        Api.getContraventions(
            (data) => setAllContraventions(data),
            (error) => console.log(error),
            organisationId, token
        )
        getSiteContraventions()
    }, [location])


    const handleDelete = () => {
        Api.deleteSiteVariableAnprRange(data => {
        }, error => console.log(error), siteId, rangeId, organisationId, token)
    }

    useEffect(() => {
        const isAnyCommonContraventionInvalid = (
            (contraventionForOverStayEnabled && stringHelpers.isNullOrEmpty(overstayContraventionId))
            || (contraventionForShortReturnEnabled && stringHelpers.isNullOrEmpty(shortReturnContraventionId))
        )

        const isAnyBasicVariableAnprFieldInvalid = (
            stringHelpers.isNullOrEmpty(name)
            || !isToDateAfterFromDate(startDate, endDate)
        )

        if (isStandardAnpr) {
            // if it's a standard anpr we only want to check if each contravention type when enabled has a non-null id
            setCanSubmit(!(
                isAnyCommonContraventionInvalid
                || (contraventionsForNotOnAllowListEnabled && stringHelpers.isNullOrEmpty(contraventionsForNotOnAllowList))
                || (overnightStaySettingsEnabled && stringHelpers.isNullOrEmpty(overnightStayContraventionId))
            ))
        }

        // if it's not a standard anpr we have 2 types
        else if (isNonEnforcement) {
            // if a non-standard anpr has nonEnforcement enabled, we check the name, start date, end date
            setCanSubmit(!isAnyBasicVariableAnprFieldInvalid)
        } else {
            // if a non-standard anpr has nonEnforcement disabled, we check the name, start date, end date
            // and then check through the common contraventions
            setCanSubmit(!(
                isAnyBasicVariableAnprFieldInvalid
                || isAnyCommonContraventionInvalid
            ))
        }

    }, [
        isStandardAnpr, isNonEnforcement, name, startDate, endDate,
        contraventionForOverStayEnabled, overstayContraventionId,
        contraventionForShortReturnEnabled, shortReturnContraventionId,
        contraventionsForNotOnAllowListEnabled, contraventionsForNotOnAllowList,
        overnightStaySettingsEnabled, overnightStayContraventionId
    ])

    return (<div className="container-fluid mandatory-date-time">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0 d-flex align-items-center">
                                        {
                                            !isNew && anprSetting 
                                            ? <>{ isStandardAnpr ? <>Standard ANPR</> : <>Variable ANPR - { anprSetting.name }</> }</>
                                            : <>Add new Variable ANPR</>
                                        }
                                        
                                    </h5>
                                </div>
                                { 
                                !isNew && !roleUtilities.isThirdPartyProcessor(user, organisationId) && !roleUtilities.isThirdPartyManager(user, organisationId) && !roleUtilities.isOrganisationProcessor(user, organisationId) &&
                                    <div className="col-auto">
                                        <Link className="btn btn-falcon-default btn-sm mr-2 py-1" type="button"
                                            to={ returnUrl }><i className="fas fa-reply"></i> Back</Link>
                                        <button type="button" className="btn btn-primary btn-sm mr-2"
                                            onClick={ () => {
                                                setIsInEdit(!isInEdit)
                                                setInitialValues(anprSetting)
                                            } }>
                                            <i className="fas fa-edit mr-2"></i>Edit
                                        </button>
                                        { (roleUtilities.isOrganisationAdminOrManager(user, organisationId) || roleUtilities.isClientManager(user, organisationId) || (roleUtilities.isClient(user, organisationId) && !stringHelpers.isNullOrEmpty(anprSetting.endDate) && isDateTimeElapsed(anprSetting.endDate))) && !isStandardAnpr &&
                                            <button
                                                className="btn btn-falcon-default btn-sm dropdown-toggle py-2 dropdown-caret-none"
                                                type="button" data-toggle="dropdown" aria-haspopup="true"
                                                aria-expanded="true"><i className="fas fa-ellipsis-h"></i></button> }
                                        <div className="dropdown-menu dropdown-menu-right" x-placement="bottom-start">
                                            <button onClick={ () => setShowDeleteModal(true) }
                                                className="dropdown-item text-danger">
                                                <i className="fas fa-times"></i> Delete Setting
                                            </button>
                                        </div>
                                    </div> 
                                    }
                            </div>
                        </div>
                        {isLoading ? <Loader/> : isInEdit ? <>
                            <div className="card-body bg-light border-top details-container">
                                <div className="row mb-1">
                                    <div className=" col-md-4 col-12 pb-0 ">
                                        <p className="font-weight-semi-bold m-0">Name<span
                                            className="req"></span></p>
                                    </div>
                                    <div className="col-md-4 col-12  pb-0">
                                        <div className="form-group m-0">
                                            <input required className="form-control mb-0" type="text"
                                                   value={isStandardAnpr ? "Standard ANPR" : name}
                                                   readOnly={isStandardAnpr}
                                                   onChange={(e) => {
                                                       setName(e.target.value)
                                                       formUtilities.requiredField(e.target.parentNode, e.target.value)
                                                   }}
                                            />
                                            <small className='invalid-feedback text-danger'>Please enter a
                                                name</small>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-1">
                                    <div className="col-md-4 col-12 ">
                                        <p className="font-weight-semi-bold  mt-1 mb-1">Enabled</p>
                                    </div>
                                    <div className="col-md-4 col-12  pt-1">
                                        <div className='custom-control custom-switch'>
                                            <input className="custom-control-input" type="checkbox"
                                                   id="anpr-enabled-toggle" checked={isEnabled}
                                                   onChange={(e) => setIsEnabled(!isEnabled)}/>
                                            <label className="custom-control-label custom-toggle"
                                                   htmlFor="anpr-enabled-toggle"></label>
                                            {isEnabled ? <>Yes</> : <>No</>}
                                        </div>
                                    </div>
                                </div>
                                {!isStandardAnpr && <div className="row mb-1">
                                    <div className=" col-md-4 col-12 pb-0 ">
                                        <p className="font-weight-semi-bold m-0">Suspend Enforcement</p>
                                    </div>
                                    <div className="col-md-4 col-12 ">
                                        <div className='custom-control custom-switch'>
                                            <input className="custom-control-input" type="checkbox"
                                                   id="non-enforcement-enabled-toggle"
                                                   checked={isNonEnforcement}
                                                   onChange={(e) => setIsNonEnforcement(!isNonEnforcement)}/>
                                            <label className="custom-control-label custom-toggle"
                                                   htmlFor="non-enforcement-enabled-toggle"></label>
                                            {isNonEnforcement ? <>Yes</> : <>No</>}
                                        </div>
                                    </div>
                                </div>}

                                {showContraventionSettings && <>
                                    <div className="row mb-1">
                                        <div className="col-md-4 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Consideration
                                                Period
                                                (mins)</p>
                                            <p className="text-secondary fs--2">Maximum length of stay
                                                between entry
                                                and exit that does not result in a parking charge.</p>
                                        </div>
                                        <div className="col-md-4 col-12  pt-1">
                                            <div className="form-group mb-1">
                                                <input className="form-control mb-0" type="number"
                                                       value={considerationPeriodMinutes}
                                                       onChange={(e) => setConsiderationPeriodMinutes(e.target.value)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className=" col-md-4 col-12 ">
                                            <p className="font-weight-semi-bold m-0">Allow List Entry
                                                Grace</p>
                                            <p className="text-secondary fs--2">Following entry, vehicles on
                                                allow
                                                list must be either added via portal or make a payment
                                                within this
                                                time to avoid a breach.</p>
                                        </div>
                                        <div className="col-md-4  col-12">
                                            <div className="form-group mb-1">
                                                <MinutesInputWithUnit
                                                    numberOfMinutes={allowListEntryGraceMinutes}
                                                    handleChange={setAllowListEntryGraceMinutes}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className=" col-md-4 col-12 ">
                                            <p className="font-weight-semi-bold m-0">Allow List Exit
                                                Grace</p>
                                            <p className="text-secondary fs--2">Following payment expiry or
                                                portal
                                                permit expiry, vehicles on allow list must exit within this
                                                time to
                                                avoid a breach.</p>
                                        </div>
                                        <div className="col-md-4 col-12 ">
                                            <div className="form-group mb-1">
                                                <MinutesInputWithUnit
                                                    numberOfMinutes={allowListExitGraceMinutes}
                                                    handleChange={setAllowListExitGraceMinutes}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-4">
                                        <div className=" col-md-4 col-12 ">
                                            <p className="font-weight-semi-bold m-0">Allow List Duration
                                                Grace</p>
                                        </div>
                                        <div className="col-md-4 col-12 ">
                                            <div className="form-group mb-1">
                                                <MinutesInputWithUnit
                                                    numberOfMinutes={allowListDurationGraceMinutes}
                                                    handleChange={setAllowListDurationGraceMinutes}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className=" col-md-4 col-12 ">
                                            <p className="font-weight-semi-bold m-0">Parking Session Limit
                                                (mins)</p>
                                            <p className="text-secondary fs--2">Limits the duration of a
                                                parking
                                                session - no breaches will be created for any sessions
                                                exceeding
                                                this limit.</p>
                                        </div>
                                        <div className="col-md-4 col-12 ">
                                            <div className="form-group mb-1">
                                                <input className="form-control mb-0" type="number"
                                                       value={enforcementLimitMinutes}
                                                       onChange={(e) => setEnforcementLimitMinutes(e.target.value)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className=" col-md-4 col-12 pb-0 ">
                                            <p className="font-weight-semi-bold m-0">Maximum Stay (mins)</p>
                                            <p className="m-0 text-secondary fs--2">Applicable for
                                                maximum-stay
                                                sites.</p>
                                        </div>
                                        <div className="col-md-4 col-12  pb-0">
                                            <div className="form-group m-0">
                                                <input className="form-control mb-0" type="number"
                                                       value={maxAllowedParkingDurationMinutes}
                                                       onChange={(e) => setMaxAllowedParkingDurationMinutes(e.target.value)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="border-dashed border-bottom-0"></hr>
                                    <h5 className="font-weight-semi-bold text-left mb-2">Over Stay
                                        Contravention</h5>
                                    <div className="row align-items-center mb-2">
                                        <div className=" col-md-4 col-12 ">
                                            <p className="font-weight-semi-bold m-0">Enabled</p>
                                        </div>
                                        <div className="col-md-4 col-12 ">

                                            <div className="custom-control custom-switch">

                                                <input className="custom-control-input" type="checkbox"
                                                       id="variable-contraventions-for-overstay-enabled"
                                                       checked={contraventionForOverStayEnabled}
                                                       onChange={e => {
                                                           setContraventionForOverStayEnabled(!contraventionForOverStayEnabled)
                                                           if (!e.target.checked) {
                                                               setOverstayContraventionId(null)
                                                           }
                                                       }}/>
                                                <label className="custom-control-label custom-toggle"
                                                       htmlFor="variable-contraventions-for-overstay-enabled"></label>
                                                {contraventionForOverStayEnabled ? <>Yes</> : <>No</>}

                                            </div>
                                        </div>
                                    </div>


                                    {contraventionForOverStayEnabled && <div className="row">
                                        <div className="col-md-4 col-12">
                                            <p className="font-weight-semi-bold m-0">Contravention</p>
                                        </div>
                                        <div className="col-md-4 col-12 ">
                                            <div className="form-group">
                                                {

                                                    <select
                                                        className='w-100 border rounded py-1 form-control'
                                                        value={overstayContraventionId}
                                                        onChange={e => setOverstayContraventionId(e.target.value)}
                                                    >
                                                        <option value="">Select Contravention</option>
                                                        {!arrayUtilities.isNullOrEmpty(siteContraventions) && siteContraventions.map(item =>
                                                            <option value={item.contraventionId}
                                                                    key={item.contraventionId}>{item.contraventionName} ({Enums.ContraventionTypes[item.contraventionType]})</option>)}
                                                    </select>}
                                            </div>
                                        </div>
                                    </div>}

                                    {isStandardAnpr && <>
                                        <hr className="border-dashed border-bottom-0"></hr>
                                        <div className="row mb-1">
                                            <div className="col-md-3 col-12">
                                                <h5 className="font-weight-semi-bold text-left">Not On Allow
                                                    List
                                                    Contravention</h5>
                                                <p className="text-secondary fs--2">Applied when a vehicle
                                                    has
                                                    no allow
                                                    list entry.</p>
                                            </div>
                                        </div>
                                        <div className="row align-items-center mb-1">
                                            <div className=" col-md-4 col-12 ">
                                                <p className="font-weight-semi-bold m-0">Enabled</p>
                                            </div>
                                            <div className="col-md-6 col-12 grid-two-col">
                                                <div className="custom-control custom-switch">
                                                    <input className="custom-control-input" type="checkbox"
                                                           id="contraventions-for-not-on-allow-list-enabled"
                                                           checked={contraventionsForNotOnAllowListEnabled}
                                                           onChange={e => {
                                                               setContraventionsForNotOnAllowListEnabled(!contraventionsForNotOnAllowListEnabled)
                                                               if (!e.target.checked) {
                                                                   setContraventionsForNotOnAllowList("")
                                                               }
                                                           }}/>
                                                    <label className="custom-control-label custom-toggle"
                                                           htmlFor="contraventions-for-not-on-allow-list-enabled"></label>
                                                    {contraventionsForNotOnAllowListEnabled ? <>Yes</> : <>No</>}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 col-12">
                                                <p className="font-weight-semi-bold m-0">Contravention</p>
                                            </div>
                                            <div className="col-md-4 col-12">
                                                <div className="form-group">
                                                    {!arrayUtilities.isNullOrEmpty(siteContraventions) && contraventionsForNotOnAllowListEnabled && <>
                                                        <select
                                                            required
                                                            value={contraventionsForNotOnAllowList}
                                                            className='w-100 border rounded py-1 form-control'
                                                            onChange={e => {
                                                                setContraventionsForNotOnAllowList(e.target.value)
                                                                formUtilities.requiredField(e.target.parentNode, e.target.value)
                                                            }}
                                                        >
                                                            <option value="">Select Contravention</option>
                                                            {siteContraventions.map(contravention => <option
                                                                value={contravention.contraventionId}
                                                                key={contravention.contraventionId}>{contravention.contraventionName} ({Enums.ContraventionTypes[contravention.contraventionType]})</option>)}
                                                        </select>
                                                        <small className='invalid-feedback text-danger'>Please
                                                            select a
                                                            contravention</small>
                                                    </>}
                                                </div>
                                            </div>
                                        </div>
                                    </>}

                                    <>
                                        <hr className="border-dashed border-bottom-0"></hr>
                                        <h5 className="font-weight-semi-bold text-left mb-2">Short Return
                                            Contravention</h5>
                                        <div className="row align-items-center mb-2">
                                            <div className=" col-md-4 col-12 ">
                                                <p className="font-weight-semi-bold m-0">Enabled</p>
                                            </div>
                                            <div className="col-md-4 col-12 ">

                                                <div className="custom-control custom-switch">
                                                    <input className="custom-control-input" type="checkbox"
                                                           id="variable-contraventions-for-short-return-enabled"
                                                           checked={contraventionForShortReturnEnabled}
                                                           onChange={e => {
                                                               setContraventionForShortReturnEnabled(!contraventionForShortReturnEnabled)
                                                               if (!e.target.checked) {
                                                                   setShortReturnContraventionId(null)
                                                               }
                                                           }}/>
                                                    <label
                                                        className="custom-control-label custom-toggle"
                                                        htmlFor="variable-contraventions-for-short-return-enabled"></label>
                                                    {contraventionForShortReturnEnabled ? <>Yes</> : <>No</>}
                                                </div>
                                            </div>
                                        </div>
                                        {contraventionForShortReturnEnabled && <>
                                            <div className={`row mb-2`}>
                                                <div className=" col-md-4 col-12 ">
                                                    <p className="font-weight-semi-bold m-0">Contravention</p>
                                                </div>
                                                <div className="col-md-4 col-12 ">
                                                    <div className="form-group mb-0">
                                                        {

                                                            <>
                                                                <select
                                                                    className='w-100 border rounded py-1 px-3 form-control'
                                                                    value={shortReturnContraventionId}
                                                                    onChange={e => setShortReturnContraventionId(e.target.value)}
                                                                >
                                                                    <option value="">Select
                                                                        Contravention
                                                                    </option>
                                                                    {!arrayUtilities.isNullOrEmpty(siteContraventions) && siteContraventions.map(item =>
                                                                        <option
                                                                            value={item.contraventionId}
                                                                            key={item.contraventionId}>{item.contraventionName} ({Enums.ContraventionTypes[item.contraventionType]})</option>)}
                                                                </select>
                                                            </>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-4 col-12">
                                                    <p className="font-weight-semi-bold m-0">No Return
                                                        Within
                                                        (mins)</p>
                                                </div>
                                                <div className="col-md-4 col-12 ">
                                                    <div className="form-group mb-1">
                                                        {<input className="form-control mb-0"
                                                                type="number"
                                                                value={noReturnWithinMinutes}
                                                                onChange={(e) => setNoReturnWithinMinutes(e.target.value)}/>}
                                                    </div>
                                                </div>
                                            </div>
                                            {isStandardAnpr && <div className="row align-items-center mb-2">
                                                <div className="col-md-4 col-12">
                                                    <p className="font-weight-semi-bold m-0">Enforce Short Return for Allow List Entries</p>
                                                    <p className="text-secondary fs--2">Vehicles on the allow list can still
                                                        receive a short return breach.</p>
                                                </div>
                                                <div className="col-md-4 col-12 ">
                                                    <div className="custom-control custom-switch">
                                                        <input className="custom-control-input" type="checkbox"
                                                               id="enforce-short-return-for-allow-list-entries"
                                                               checked={enforceShortReturnForAllowListEntries}
                                                               onChange={() => setEnforceShortReturnForAllowListEntries(!enforceShortReturnForAllowListEntries)}/>
                                                        <label
                                                            className="custom-control-label custom-toggle"
                                                            htmlFor="enforce-short-return-for-allow-list-entries"></label>
                                                        {enforceShortReturnForAllowListEntries ? <>Yes</> : <>No</>}
                                                    </div>
                                                </div>
                                            </div>}
                                        </>}

                                        {isStandardAnpr && <>
                                            <hr className="border-dashed border-bottom-0"></hr>
                                            <div className="row">
                                                <div className="col-12 ">
                                                    <h5 className="font-weight-semi-bold mt-1 text-left">Overnight
                                                        Stay Contravention</h5>
                                                </div>
                                            </div>
                                            <div className="row align-items-center mb-2">
                                                <div className=" col-md-4 col-12 ">
                                                    <p className="font-weight-semi-bold mt-1 mb-1">Enabled</p>
                                                </div>
                                                <div className="col-md-4 col-12 ">
                                                    <div className="custom-control custom-switch">
                                                        <input className="custom-control-input"
                                                               type="checkbox"
                                                               id="overnight-stay-settings-enabled"
                                                               checked={overnightStaySettingsEnabled}
                                                               onChange={e => {
                                                                   setOvernightStaySettingsEnabled(!overnightStaySettingsEnabled)
                                                                   if (e.target.checked) {
                                                                       setOvernightStayStartTime(60);
                                                                       setOvernightStayEndTime(300)
                                                                   } else {
                                                                       setOvernightStayContraventionId(null)
                                                                   }
                                                               }}/>
                                                        <label
                                                            className="custom-control-label custom-toggle"
                                                            htmlFor="overnight-stay-settings-enabled"></label>
                                                        {overnightStaySettingsEnabled ? <>Yes</> : <>No</>}
                                                    </div>
                                                </div>
                                            </div>

                                            {overnightStaySettingsEnabled && <>
                                                <div className="row">
                                                    <div className=" col-md-4 col-12 ">
                                                        <p className="font-weight-semi-bold mt-1 mb-1">Contravention</p>
                                                    </div>
                                                    <div className="col-md-4 col-12 ">
                                                        <div className="form-group">
                                                            <select required
                                                                    defaultValue={overnightStayContraventionId}
                                                                    onChange={e => {
                                                                        setOvernightStayContraventionId(e.target.value);
                                                                        formUtilities.requiredField(e.target.parentNode, e.target.value)
                                                                    }}
                                                                    className='w-100 border rounded py-1 px-3 form-control'>
                                                                <option value="">Select
                                                                    Contravention
                                                                </option>
                                                                {allContraventions.map(item => <option
                                                                    value={item.id}>{item.name} ({Enums.ContraventionTypes[item.contraventionType]})</option>)}
                                                            </select>
                                                            <small
                                                                className='invalid-feedback text-danger'>Please
                                                                select a contravention</small>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mb-2">
                                                    <div className="col-md-4 col-12">
                                                        <p className="font-weight-semi-bold mt-1 mb-1">Time
                                                            Range</p>
                                                    </div>
                                                    <div className="col-md-4 col-12 ">
                                                        <MultiValueRangeSlider
                                                            lowerLimit={720}
                                                            upperLimit={720}
                                                            handleChange={sliderVal => {
                                                                setOvernightStayStartTime(sliderVal[0]);
                                                                setOvernightStayStartTimeFormattedString(stringHelpers.formatMinutesToTwentyFourHourClock(sliderVal[0]))
                                                                setOvernightStayEndTime(sliderVal[1])
                                                                setOvernightStayEndTimeFormattedString(stringHelpers.formatMinutesToTwentyFourHourClock(sliderVal[1]))
                                                            }}
                                                            maxValue={overnightStayEndTime}
                                                            minValue={overnightStayStartTime}
                                                            leftThumbFormattedString={overnightStayStartTimeFormattedString}
                                                            rightThumbFormattedString={overnightStayEndTimeFormattedString}
                                                            step={1}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-4 col-12">
                                                        <p className="font-weight-semi-bold mt-1 mb-1">Grace
                                                            Period (mins)</p>
                                                    </div>
                                                    <div className="col-md-4 col-12 ">
                                                        <div className="form-group">
                                                            <input className="form-control mb-0"
                                                                   min="0" type='number'
                                                                   value={overnightStayGraceMinutes}
                                                                   onChange={e => setOvernightStayGraceMinutes(e.target.value)}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>}
                                        </>}

                                        <hr className="border-dashed border-bottom-0"></hr>
                                        <div className="row mb-2">
                                            <div className="col-md-4 col-12 ">
                                                <h5 className="font-weight-semi-bold mt-1 text-left">Pay and
                                                    Display</h5>
                                            </div>
                                        </div>
                                        <div className="row align-items-center mb-2">
                                            <div className=" col-md-4 col-12 ">
                                                <p className="font-weight-semi-bold m-0">Enabled</p>
                                            </div>
                                            <div className="col-md-4 col-12 ">
                                                <div className="custom-control custom-switch">
                                                    <input className="custom-control-input" type="checkbox"
                                                           id="variable-pay-display-enabled"
                                                           checked={isPayAndDisplayEnabled}
                                                           onChange={() => setIsPayAndDisplayEnabled(!isPayAndDisplayEnabled)}/>
                                                    <label
                                                        className="custom-control-label custom-toggle"
                                                        htmlFor="variable-pay-display-enabled"></label>
                                                    {isPayAndDisplayEnabled ? <>Yes</> : <>No</>}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mb-2">
                                            <div className=" col-md-4 col-12 ">
                                                <p className="font-weight-semi-bold m-0">Free parking duration</p>
                                            </div>
                                            <div className="col-md-4 col-12 ">
                                                <div className="form-group mb-1">
                                                    <MinutesInputWithUnit
                                                        numberOfMinutes={freeParkingMinutes}
                                                        handleChange={setFreeParkingMinutes}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mb-2">
                                            <div className=" col-md-4 col-12 ">
                                                <p className="font-weight-semi-bold m-0">Contravention for
                                                    Failure to
                                                    Make Payment</p>
                                            </div>
                                            <div className="col-md-4 col-12 ">
                                                <div className="form-group mb-1">
                                                    <select
                                                        className='w-100 border rounded py-1 px-3 form-control'
                                                        value={failedToMakePaymentContraventionId}
                                                        onChange={e => setFailedToMakePaymentContraventionId(e.target.value)}
                                                    >
                                                        <option value="">Select Contravention</option>
                                                        {!arrayUtilities.isNullOrEmpty(siteContraventions) && siteContraventions.map(item =>
                                                            <option value={item.contraventionId}
                                                                    key={item.contraventionId}>{item.contraventionName} ({Enums.ContraventionTypes[item.contraventionType]})</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mb-2">
                                            <div className=" col-md-4 col-12 ">
                                                <p className="font-weight-semi-bold mt-1 mb-1">Contravention
                                                    for
                                                    Overstayed Payment Period</p>
                                            </div>
                                            <div className="col-md-4 col-12 ">
                                                <div className="form-group mb-0">
                                                    <select
                                                        className='w-100 border rounded py-1 px-3 form-control'
                                                        value={overstayedPaymentPeriodContraventionId}
                                                        onChange={e => setOverstayedPaymentPeriodContraventionId(e.target.value)}
                                                    >
                                                        <option value="">Select Contravention</option>
                                                        {!arrayUtilities.isNullOrEmpty(siteContraventions) && siteContraventions.map(item =>
                                                            <option value={item.contraventionId}
                                                                    key={item.contraventionId}>{item.contraventionName} ({Enums.ContraventionTypes[item.contraventionType]})</option>)}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                </>}

                                {!isStandardAnpr && <>
                                    <hr className="border-dashed border-bottom-0"></hr>
                                    <h5 className="font-weight-semi-bold mt-1 text-left">Date/Time
                                        Details</h5>
                                    <div className="row mb-3">
                                        <div className="col-md-4 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">Start Date</p>
                                        </div>
                                        <div className="col-md-4 col-12 ">
                                            <div className="form-group mb-0">
                                                <input required className="form-control mb-1"
                                                       type="datetime-local"
                                                       value={toInputFieldDateTimeString(startDate)}
                                                       onChange={(e) => setStartDate(e.target.value)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-4 col-12 ">
                                            <p className="font-weight-semi-bold  mt-1 mb-1">End Date</p>
                                        </div>
                                        <div className="col-md-4 col-12 ">
                                            <div className="form-group mb-0">
                                                <input required className="form-control mb-1"
                                                       type="datetime-local"
                                                       value={toInputFieldDateTimeString(endDate)}
                                                       onChange={(e) => setEndDate(e.target.value) }/>
                                                <small className='invalid-feedback text-danger'>Please
                                                    enter
                                                    an
                                                    end
                                                    date</small>
                                            </div>
                                            {!isToDateAfterFromDate(startDate, endDate) &&
                                                <small className='fs--1 text-danger'>End date cannot be
                                                    before
                                                    start
                                                    date&nbsp;<i
                                                        className='fas fa-exclamation-circle'></i></small>}
                                        </div>
                                    </div>

                                    <div
                                        className={`row mt-3 ${validOnlyOnSpecificDays ? "mb-3" : ""}`}>
                                        <div className="col-md-4 col-12 ">
                                            <p className="font-weight-semi-bold mb-1">Valid only on
                                                specific
                                                days</p>
                                        </div>
                                        <div className="col-md-4 col-12 custom-control custom-switch">
                                            <input className="custom-control-input" type="checkbox"
                                                   id="enable-any-day-week-switch"
                                                   checked={validOnlyOnSpecificDays}
                                                   onChange={e => {
                                                       setValidOnlyOnSpecificDays(!validOnlyOnSpecificDays)
                                                       if (!e.target.checked) {
                                                           setValidityDays(prevState => (prevState.map(item => ({
                                                               ...item, isEnabled: false
                                                           }))))
                                                       }
                                                   }}/>
                                            <label className="custom-control-label ml-3"
                                                   htmlFor="enable-any-day-week-switch"></label>
                                            <p className="m-0 ml-3 mt-1">{validOnlyOnSpecificDays ? <>Yes</> : <>No</>}</p>
                                        </div>
                                    </div>

                                    {validOnlyOnSpecificDays &&
                                        <div className="mt-3">
                                        {validityDays.map((day, index) => <div key={index} className="row mb-3">
                                            <div className="col-md-4 col-12 ">
                                                <p className="font-weight-semi-bold  mt-1 mb-1">{day.label}</p>
                                            </div>
                                            <div
                                                className="col-md-4 col-12 custom-control custom-switch">
                                                <input className="custom-control-input"
                                                       type="checkbox"
                                                       id={`enable-${day.label}-switch`}
                                                       checked={day.isEnabled}
                                                       onChange={e => setValidityDays(prevState => {
                                                           return prevState.toSpliced(index, 1, {
                                                               ...prevState[index], isEnabled: e.target.checked
                                                           })
                                                       })}
                                                />
                                                <label className="custom-control-label ml-3"
                                                       htmlFor={`enable-${day.label}-switch`}></label>
                                                <p className="m-0 ml-3 mt-1">{day.isEnabled ? <>Yes</> : <>No</>}</p>
                                            </div>
                                        </div>)}
                                    </div>}

                                    <div className="row my-3">
                                        <div className="col-md-4 col-12 ">
                                            <p className="font-weight-semi-bold mb-1 ">Valid only at
                                                specific times
                                                of the day</p>
                                        </div>
                                        <div className="col-md-4 col-12 custom-control custom-switch">
                                            <input className="custom-control-input" type="checkbox"
                                                   id="enable-any-time-day-switch"
                                                   checked={validOnlyAtSpecificTimes} onChange={e => {
                                                    setValidOnlyAtSpecificTimes(e.target.checked)
                                            }}/>
                                            <label className="custom-control-label ml-3"
                                                   htmlFor="enable-any-time-day-switch"></label>
                                            <p className="m-0 ml-3 mt-1">{validOnlyAtSpecificTimes ? <>Yes</> : <>No</>}</p>
                                        </div>
                                    </div>
                                    {validOnlyAtSpecificTimes &&
                                        <div className="row mb-3">
                                        <div className="col-md-4 col-12 ">
                                            <p className="font-weight-semi-bold mb-1">Time Range</p>
                                        </div>
                                        <div className="col-md-4 col-12">
                                            <TimeRangeSlider
                                                use24HourClock
                                                startTime={enabledTimes.from}
                                                endTime={enabledTimes.to}
                                                onChange={value => {
                                                    const withSeconds = (time) => time.split(':').length === 2 ? `${time}:00` : time;
                                                    setEnabledTimes({
                                                        from: withSeconds(value.startTime),
                                                        to: withSeconds(value.endTime)
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>}
                                </>}

                            </div>
                            <div className="card-footer border-top ">
                                <div className="row client-edit-buttons">
                                    <div className="col-12 col-sm-auto ml-auto pl-0">
                                        <div id="dashboard-actions">
                                            <button type="button" className="btn btn-falcon-default btn-sm ml-2"
                                                    onClick={() => {
                                                        if (isNew) {
                                                            history.push(returnUrl)
                                                        } else {
                                                            setIsInEdit(false)
                                                        }
                                                    }}>
                                                <i className="fas fa-times mr-1"></i>
                                                Cancel
                                            </button>
                                            <button
                                                disabled={!canSubmit}
                                                type="button" className="btn btn-success btn-sm ml-2"
                                                onClick={() => submit()}>
                                                <i className="fas fa-check mr-1"></i>
                                                Confirm
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </> : anprSetting && <AnprSettingDisplay
                            isStandardAnpr={isStandardAnpr}
                            organisationId={organisationId}
                            anprSetting={anprSetting}
                            validityDays={validityDays}
                            allContraventions={allContraventions}
                        />}

                    </div>
                </div>
            </div>
            {!stringHelpers.isNullOrEmpty(errorMessage) &&
                <ErrorModal message={errorMessage} onHide={() => setErrorMessage(null)}/>}
            {showDeleteModal && <Modal show onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header>
                    <Modal.Title className="d-flex gap-2 align-items-center text-danger">Delete Variable ANPR
                        Setting</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="font-weight-semi-bold mt-1 mb-2">Are you sure you want to proceed?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-falcon-default btn-sm ml-2"
                            onClick={() => setShowDeleteModal(false)}>Cancel
                    </button>
                    <button type="button" className="btn btn-danger btn-sm ml-2" onClick={() => {
                        setShowDeleteModal(false)
                        handleDelete()
                    }}>Delete
                    </button>
                </Modal.Footer>
            </Modal>}
        </div>)
}